<template>
  <div :class="{ 'has-portrait': portrait, 'has-title': true, 'has-description': description, 'surface-title': true }">
    <div ref="container" class="title-container" dir="auto">
      <processed-image
        v-if="portrait"
        id="portrait"
        :src="portrait"
        :transforms="{ preset: 'icon', width: 64, height: 64 }"
        v-t:alt="'Icon'"
      />
      <div class="title-text">
        <h1 class="title-heading" @dblclick="tryModify">{{ title || '&nbsp;' }}</h1>
        <h2
          v-if="description"
          class="title-description caption-type"
          @dblclick="tryModify"
          v-html="hyperlinkedDescription"
        />
        <surface-builder v-if="xBuilder" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import t from 'vuedirectives/t'
import SurfaceBuilder from 'vuecomponents/surface_builder'
import ProcessedImage from 'vuecomponents/processed_image'
import { mapGetters } from 'vuex'
import { link } from 'bits/autolinker'
export default {
  components: { SurfaceBuilder, ProcessedImage },
  directives: { t },
  watch: {
    title() {
      this.$emit('title-changed')
    },
    description() {
      this.$emit('description-changed')
    },
  },
  computed: {
    ...mapGetters(['portrait', 'title', 'description', 'canIAdminister']),
    xBuilder() {
      return !this.$store.state.isEmbedded
    },
    hyperlinkedDescription() {
      return link(this.description)
    },
  },
  methods: {
    tryModify() {
      if (this.canIAdminister) {
        this.$store.dispatch('settings/showSettingsPanel')
      }
    },
  },
}
</script>
